"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = exports.encrypt = exports.decryptString = exports.encryptString = exports.randomKeyPair = exports.secretLength = void 0;
const base64_js_1 = require("base64-js");
const AES = require("./AES");
const Utils_1 = require("./Utils");
const keyParams = {
    name: 'RSA-OAEP',
    modulusLength: 2048,
    publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
    hash: 'SHA-256',
};
exports.secretLength = 256;
const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
/**
 * Converts a base64-encoded key into a WebCrypto key object.
 * @param input base64-encoded string
 */
function stringToKey(input, isPublic) {
    return crypto.subtle.importKey('jwk', JSON.parse(input), keyParams, true, [
        isPublic ? 'encrypt' : 'decrypt',
    ]);
}
function randomKeyPair() {
    return __awaiter(this, void 0, void 0, function* () {
        const keyPair = (yield crypto.subtle.generateKey(keyParams, true, [
            'encrypt',
            'decrypt',
        ]));
        const publicKey = yield crypto.subtle.exportKey('jwk', keyPair.publicKey);
        const privateKey = yield crypto.subtle.exportKey('jwk', keyPair.privateKey);
        return {
            publicKey: JSON.stringify(publicKey),
            privateKey: JSON.stringify(privateKey),
        };
    });
}
exports.randomKeyPair = randomKeyPair;
/**
 * Encrypts a string and returns a base64 encoded ciphertext.
 * @param keyStr public key
 * @param data data to encrypt
 */
function encryptString(key, plaintext) {
    return __awaiter(this, void 0, void 0, function* () {
        return base64_js_1.fromByteArray(yield encrypt(key, textEncoder.encode(plaintext)));
    });
}
exports.encryptString = encryptString;
/**
 * Decrypts a string.
 * @param keyStr private key
 * @param data data to decrypt
 */
function decryptString(key, encryptedString) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!encryptedString) {
            return null;
        }
        return textDecoder.decode(yield decrypt(key, base64_js_1.toByteArray(encryptedString)));
    });
}
exports.decryptString = decryptString;
/**
 * Encrypts a byte array.
 * @param keyStr public key
 * @param data data to encrypt
 */
function encrypt(keyStr, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const publicKey = yield stringToKey(keyStr, true);
        const secret = yield AES.randomKeyBytes();
        const encryptedSecret = yield crypto.subtle.encrypt({ name: 'RSA-OAEP' }, publicKey, secret);
        const encrypted = yield AES.encrypt(secret, data);
        return Utils_1.joinArrays(new Uint8Array(encryptedSecret), encrypted);
    });
}
exports.encrypt = encrypt;
/**
 * Decrypts a byte array.
 * @param keyStr private key
 * @param data data to decrypt
 */
function decrypt(keyStr, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const privateKey = yield stringToKey(keyStr, false);
        if (data instanceof ArrayBuffer) {
            data = new Uint8Array(data);
        }
        const [encryptedSecret, realData] = Utils_1.splitArray(data, exports.secretLength);
        const secret = yield crypto.subtle.decrypt({ name: 'RSA-OAEP' }, privateKey, encryptedSecret);
        return yield AES.decrypt(secret, realData);
    });
}
exports.decrypt = decrypt;
//# sourceMappingURL=RSA.js.map